import type { AppRouteRecord } from '../types';
import { ROUTE_NAMES, ROUTE_PATHS } from '../constants';

export const profileRoutes: AppRouteRecord[] = [
  {
    path: ROUTE_PATHS.PROFILE,
    name: ROUTE_NAMES.PROFILE,
    component: () => import('@/pages/ProfilePage.vue'),
  },
];
